<sa-loading *ngIf="formLoading$ | async"></sa-loading>

<div class="outer-container" *ngIf="!(formLoading$ | async)">
  <div class="title flex justify-between">
    <h3>Loaders</h3>
  </div>
  <div class="form-container">
    <ng-container *ngIf="(currentFracFcpos$ | async).length; else noFcpo">
      <form
        autocomplete="off"
        (submit)="submit()"
        [formGroup]="loaderDirectionForm"
        class="flex flex-col gap-2"
        *ngIf="!(formLoading$ | async)"
      >
        <div
          class="mines"
          *ngIf="loaderDirectionForm.controls['mines'].value && loaderDirectionForm.controls['mines'].value.length"
        >
          <span *ngFor="let mine of loaderDirectionForm.controls['mines'].value; trackBy: trackById">
            <div class="form-field-label">Directions to {{ mine.site.name }}</div>
            <mat-form-field class="form-field" appearance="outline">
              <textarea
                matInput
                maxlength="5000"
                matAutosizeMinRows="2"
                matAutosizeMaxRows="10"
                matTextareaAutosize
                [formControl]="loaderDirectionForm.controls['mine_' + mine.id + '_direction']"
              >
              </textarea>
              <mat-hint align="end"
                >{{ loaderDirectionForm.controls['mine_' + mine.id + '_direction'].value?.length || 0 }} /5000</mat-hint
              >
            </mat-form-field>
          </span>
        </div>
        <div class="action-buttons" style="overflow: auto">
          <button mat-flat-button color="primary" type="submit" class="next-btn">
            Next
          </button>
        </div>
      </form>
    </ng-container>
    <ng-template #noFcpo>
      <div class="pb-3">
        No Purchase Order Created
      </div>
    </ng-template>
  </div>
</div>
